import { useEffect, useMemo, useState } from 'react';
import { dateCountdown, countdownStringFormat, daysDifference } from '~globals/dateCountdown';
import { withinDateRange } from '~globals/withinDateRange';
import { useAppSelector } from '~hooks/useRedux';
import BannerClock from '~images/banners/banner-clock.svg';

export const OepBanner = () => {
    const deadlines = useAppSelector((state) => state.global.oepStateConfig);
    const period = useAppSelector((state) => state.global.oepStatePeriod);
    const [currentDate, setCurrentDate] = useState<Date>(new Date())

    if (!period || !deadlines || deadlines.length === 0) return null;

    const deadLine = deadlines.find((banner) => {
        const [start, end] = banner.when
        return withinDateRange(new Date(), new Date(start), new Date(end))
    })

    useEffect(() => {
        const timer = setInterval(() => setCurrentDate(() => new Date()), 60000)
        return () => clearInterval(timer)
    }, [])

    const remaining = useMemo(() => {
        if (!deadLine) return null

        if (deadLine?.countdown) {
            return dateCountdown(new Date(deadLine.countdown.to))
        }
        else {
            const toDate = new Date(period.to)
            return daysDifference(currentDate, toDate)
        }
    }, [deadLine, currentDate])

    if (!remaining) return null;

    return (
        <section
            id="oep-banner"
            className="bg-surface-primary-darker duration-500 ease-in-out flex font-poppins h-auto items-center justify-center min-h-10 px-4 py-2 text-white w-full"
        >
            <div className="flex gap-2 items-center justify-center w-full">
                <div>
                    <img src={BannerClock} alt="Clock" className="h-6 w-6" width={24} height={24} />
                </div>
                <p className="m-0 p-0 text-base">
                    {
                        typeof remaining === 'object' && (
                            <span className="font-bold">
                                {countdownStringFormat(remaining)}
                            </span>
                        )
                    }
                    {
                        typeof remaining === 'object'
                            ? deadLine?.message.replace('COUNT_DOWN_TIME', '')
                            : deadLine?.message.replace('COUNT_DOWN', remaining)
                    }
                </p>
            </div>
        </section>
    );
};
